import { landingApiRequest } from '@/lib/landing-api'

export const PURCHASED_NUMBERS_POLL_MS = 1000
export const PURCHASED_NUMBERS_ESCAPE_MS = 60000

export function normalizeLandingLuckyNumbers(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return []
  }

  return value
    .filter((item): item is string => typeof item === 'string')
    .map((item) => item.trim())
    .filter((item) => item !== '')
}

export type CreateLandingPixPaymentInput = {
  extra_numbers: number
  affiliate_code?: string
  tracking?: {
    client_session_id: string
    page_url?: string
    referrer_url?: string
    occurred_at?: string
    utm?: {
      source?: string
      medium?: string
      campaign?: string
      content?: string
      term?: string
      id?: string
    }
    click_ids?: Record<string, string>
    browser_ids?: {
      fbp?: string
      fbc?: string
    }
    query_params?: Record<string, string>
    meta?: Record<string, string | number | boolean | null>
  }
  guest?: boolean
  email?: string
}

export type CreateLandingPixPaymentData = {
  payment_id: number
  pix_id: number
  pix_key: string
  expires_at?: string | null
  checkout_token?: string | null
}

export type LandingPixPaymentStatus =
  | 'pending'
  | 'paid'
  | 'expired'
  | 'canceled'
  | 'failed'

export type LandingPixPaymentStatusData = {
  payment_id: number
  campaign_id: number
  status: LandingPixPaymentStatus
  amount: number
  quantity: number
  paid_at: string | null
  created_at: string
  expires_at?: string | null
  numbers_assigned: boolean
  lucky_numbers?: string[]
  payment_auto_auth_token?: string
}

type CreateLandingPixPaymentResponse = {
  payment_id: number
  pix_id: number
  pix_key: string
  expires_at?: string | null
  checkout_token?: string | null
}

type LandingPixPaymentStatusResponse = LandingPixPaymentStatusData

export async function createLandingPixPayment(
  token: string | null,
  campaignId: number,
  input: CreateLandingPixPaymentInput
): Promise<CreateLandingPixPaymentData> {
  return landingApiRequest<CreateLandingPixPaymentResponse>(`/api/campaigns/${campaignId}/payments/pix`, {
    method: 'POST',
    body: JSON.stringify(input),
    token: token ?? undefined,
  })
}

export async function fetchLandingPixPaymentStatus(
  token: string | null,
  campaignId: number,
  paymentId: number,
  params?: {
    checkoutToken?: string | null
    email?: string | null
  }
): Promise<LandingPixPaymentStatusData> {
  const query = new URLSearchParams()
  if (params?.checkoutToken) {
    query.set('checkout_token', params.checkoutToken)
  }
  if (params?.email) {
    query.set('email', params.email)
  }

  const suffix = query.toString() ? `?${query.toString()}` : ''
  return landingApiRequest<LandingPixPaymentStatusResponse>(
    `/api/campaigns/${campaignId}/payments/pix/${paymentId}${suffix}`,
    {
      method: 'GET',
      token: token ?? undefined,
    }
  )
}

